import { gql } from "@apollo/client";

export const createOtcOrderMutation = gql`
  mutation CreateOtcOrder($input: CreateOtcOrderInput!) {
    createOtcOrder(input: $input) {
      id
      customerId
      currency
      amount
      reference
      side
      status
    }
  }
`;

export const createOtcOrderAdminMutation = gql`
  mutation CreateOtcOrderAdmin($input: CreateOtcOrderInput!) {
    createOtcOrder_Admin(input: $input) {
      id
      customerId
      currency
      amount
      reference
      side
      status
    }
  }
`;

export const completeOtcOrderMutation = gql`
  mutation CompleteOtcOrder($id: String!, $input: CompleteOtcOrderInput) {
    completeOtcOrder_Admin(id: $id, input: $input) {
      id
      status
      side
    }
  }
`;

export const cancelOtcOrderMutation = gql`
  mutation CancelOtcOrder($id: String!, $input: CancelOtcOrderInput) {
    cancelOtcOrder_Admin(id: $id, input: $input) {
      id
      status
      side
    }
  }
`;


